export const MessageBubble = ({
  content,
  isUser,
  isSkeleton,
  onClick,
  selected,
}: {
  content: string;
  isUser?: boolean;
  isSkeleton?: boolean;
  onClick?: () => void;
  selected?: boolean;
}) => (
  <div
    className={`max-w-[70%] my-1 px-4 py-2 rounded-md bg-white border text-text-primary ${isSkeleton ? "opacity-60 animate-pulse" : ""} ${selected ? "border border-brand-blue " : ""}`}
    style={{ alignSelf: isUser ? "flex-end" : "flex-start" }}
    onClick={onClick}
  >
    {isSkeleton ? <span>...</span> : content}
  </div>
);
